<template>
  <el-card shadow="always" class="post-page">
    <PostFinished ref="finished" />
    <div slot="header" class="clearfix">
      <PageTitle title="Adicionar Pré-Postagem" subtitle="Adicione uma nova prepostagem" />
    </div>
    <PostHeader ref="header" :form="form" :data="data" @redirect="setup" />
    <el-row :gutter="32">
      <el-col :xs="24" :sm="24" :md="12">
        <PostDeclaredValue ref="declaredForm" :min="min" :max="max" :form="form" :data="data" />
        <PostDelivery ref="deliveryForm" :form="form" :data="data" />
        <PostSender ref="sender" :form="form" :data="data" />
      </el-col>
      <el-col :xs="24" :sm="24" :md="12">
        <PostServicesAditional ref="aditionalForm" :form="form" :data="data" />
        <PostDeclaredContent ref="contentForm" :form="form" :data="data" />
      </el-col>
    </el-row>
    <div class="post-footer">
      <el-button type="warning" autofocus @click="add">{{ $t("adicionar") }}</el-button>
    </div>
  </el-card>
</template>

<script>
import PageTitle from "../../layout/PageTitle.vue";
import PostHeader from "./post/PostHeader.vue";
import PostDeclaredValue from "./post/PostDeclaredValue.vue";
import PostDelivery from "./post/PostDelivery.vue";
import PostSender from "./post/PostSender.vue";
import PostServicesAditional from "./post/PostServicesAditional.vue";
import PostDeclaredContent from "./post/PostDeclaredContent.vue";
import { PrepostService } from "@/services/customers/prepost.services";
import { ServicesService } from "@/services/customers/services.services";
import PostFinished from "./post/PostFinished.vue";

export default {
  name: "PostPage",
  components: {
    PageTitle,
    PostHeader,
    PostSender,
    PostDeclaredValue,
    PostDelivery,
    PostServicesAditional,
    PostDeclaredContent,
    PostFinished,
  },
  data() {
    return {
      form: {},
      data: {},
      post: {},
      min: 0,
      max: 30000,
    };
  },
  methods: {
    setup() {
      const vm = this;
      this.data = localStorage.getItem("POST_QUOTATION") ? JSON.parse(localStorage.getItem("POST_QUOTATION")) : null;
      this.form = localStorage.getItem("QUOTATION_FORM") ? JSON.parse(localStorage.getItem("QUOTATION_FORM")) : null;

      console.log("post this.data", this.data, this.form);
      const loading = vm.$loading(vm.$options.loading);
      ServicesService.code(this.data.service)
        .then((response) => {
          vm.min = +response.valuemin;
          vm.max = +response.valuemax;
          this.$refs.header.setup(this.form, this.data);
          this.$refs.sender.setup(this.form, this.data);
          console.log("setup service", response, this.$refs.contentForm);
          this.$refs.declaredForm.setup(this.form, this.data);
          this.$refs.contentForm.setup(this.form, this.data, response);
          this.$refs.deliveryForm.setup(this.form, this.data);
          this.$refs.aditionalForm.setup(this.form, this.data);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    result() {
      const vm = this;
      console.log(vm.$refs.finished);
      vm.post.logo = vm.data.logo;
      vm.$refs.finished.open(vm.post);
    },
    add() {
      const vm = this;
      console.log(
        this.data,
        this.form,
        this.$refs.header.ruleForm,
        this.$refs.sender.ruleForm,
        this.$refs.declaredForm.ruleForm,
        this.$refs.deliveryForm.ruleForm,
        this.$refs.aditionalForm.ruleForm,
        this.$refs.contentForm.tableData,
        this.$refs.contentForm.dataNf,
        this.$refs.declaredForm.valueData
      );
      const loading = vm.$loading(vm.$options.loading);

      const nfe = this.$refs.contentForm.dataNf.hasNf;

      PrepostService.add(
        this.$refs.sender.ruleForm.customer,
        {
          sender: "",
          cep: this.$refs.sender.ruleForm.zipcode,
          federalId: this.$refs.sender.ruleForm.federalid,
          contact: this.$refs.sender.ruleForm.name,
          address: this.$refs.sender.ruleForm.address,
          neighborhood: this.$refs.sender.ruleForm.neighborhood,
          city: this.$refs.sender.ruleForm.city,
          state: this.$refs.sender.ruleForm.state,
          number: this.$refs.sender.ruleForm.number,
          extent: this.$refs.sender.ruleForm.complement,
        },
        {
          delivery: "",
          department: "",
          cep: this.$refs.deliveryForm.ruleForm.zipcode,
          contact: this.$refs.deliveryForm.ruleForm.name,
          address: this.$refs.deliveryForm.ruleForm.address,
          neighborhood: this.$refs.deliveryForm.ruleForm.neighborhood,
          city: this.$refs.deliveryForm.ruleForm.city,
          state: this.$refs.deliveryForm.ruleForm.state,
          number: this.$refs.deliveryForm.ruleForm.number,
          extent: this.$refs.deliveryForm.ruleForm.complement,
          name: this.$refs.deliveryForm.ruleForm.name,
        },
        {
          save: false,
          invoice: this.$refs.deliveryForm.ruleForm.invoice,
          request: this.$refs.deliveryForm.ruleForm.request,
          care: this.$refs.aditionalForm.ruleForm.care,
          mail: "",
          phone: this.$refs.aditionalForm.ruleForm.phone,
          federalid: this.$refs.deliveryForm.ruleForm.federalid,
          observation: this.$refs.aditionalForm.ruleForm.observation,
          whatsapp: this.$refs.aditionalForm.ruleForm.whatsapp,
        },
        {
          ownhand: this.$refs.aditionalForm.ruleForm.ownhand,
          ar: this.$refs.aditionalForm.ruleForm.warning,
          mdp: "",
          weight: +this.$refs.header.ruleForm.weight,
          quantity: 1,
          package: "",
          ardigital: this.$refs.aditionalForm.ruleForm.digital,
        },
        {
          value: this.$refs.declaredForm.valueData,
          height: +this.$refs.header.ruleForm.height,
          length: +this.$refs.header.ruleForm.length,
          width: this.$refs.header.ruleForm.width,
          diameter: 0,
          type: "001",
          typeContent: this.$refs.contentForm.ruleForm.typeContent,
          nfeKey: this.$refs.contentForm.ruleForm.nfeKey,
          nfeNumber: this.$refs.contentForm.ruleForm.nfeNumber,
          nfeSerie: this.$refs.contentForm.ruleForm.nfeSerie,
          nfeValue: this.$refs.contentForm.ruleForm.nfeValue,
          dceId: this.$refs.contentForm.ruleForm.dceId,
        },
        this.data.service,
        null,
        this.$refs.contentForm.tableData,
        this.$refs.contentForm.dataNf
      )
        .then((response) => {
          console.log("data", response);
          vm.post = response[0];
          vm.post.logo = vm.data.logo;
          vm.$refs.finished.open(vm.post);
          this.$message({
            type: "success",
            message: `Prepostagem adicionada com sucesso!`,
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    this.setup();
  },
};
</script>

<style>
.alert-title .el-alert__content .el-alert__title {
  font-size: 14px !important;
}
.post-page .post-section {
  padding-top: 28px;
}
.post-page .post-section__title {
  margin: 0 0 18px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #909399;
}
.post-page .post-form .el-form-item {
  margin-bottom: 18px;
}
.post-page .post-form .el-form-item__label {
  padding: 0 0 6px !important;
  font-size: 12px;
  line-height: 18px;
  color: #606266;
}
.post-page .post-form .el-input__inner,
.post-page .post-form .el-textarea__inner {
  border-color: #dcdfe6 !important;
}
.post-page .post-form .el-select,
.post-page .post-form .el-date-editor {
  width: 100%;
}
.post-page .post-form .post-button-block {
  width: 100%;
}
.post-page .post-form .el-radio {
  margin-right: 24px;
  margin-bottom: 4px;
}
.post-page .el-alert {
  margin-bottom: 18px;
  padding: 10px 14px;
}
.post-page .el-alert__title {
  font-size: 13px;
  line-height: 1.5;
}
.post-page .post-table {
  margin-top: 4px;
}
.post-page .post-table::before {
  display: none;
}
.post-page .post-table th {
  font-size: 12px;
  font-weight: 600;
  color: #909399;
  background-color: transparent;
}
.post-page .post-table__remove {
  color: #f56c6c;
  padding: 0;
}
.post-page .post-footer {
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}
</style>
